import { createFileRoute } from "@tanstack/react-router";
import NewsPage from "@project/user/pages/community/news";

export const Route = createFileRoute("/_user/_community/news")({
  head: () => ({ meta: [{ title: "News & Updates — Jivandhara" }] }),
  component: NewsPage,
});
